module.exports = __webpack_public_path__ + "img/11.5ab588e4.png";